<!--
  - @copyright Internet Business Partner, all rights reserved (c) 2020
  - @author    Marek Lisiecki <m.lisiecki@ibp.net.pl>
  - @license   Commercial
  -->

<template>
    <div id="gMap" ref="gMap"></div>
</template>

<script>
export default {
    name: "GoogleMaps",
    data () {
        return {
            map: null
        };
    },
    props: {
        lat: { type: Number, required: true },
        lng: { type: Number, required: true }
    },
    mounted () {
        const gMaps = window.google.maps;
        //https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=AIzaSyAIf21Gn3ySH-EW3FRMoZCZ6tzbEd0dBYw
        /*
        await (new google.maps.Geocoder())
            .geocode(
                {
                    'address' : 'Polska, Gliwice, Graniczna 55'
                },
                ( results, status ) => {
                    if ( status == google.maps.GeocoderStatus.OK ) {
                        var r = results[0].geometry.location;
                        console.log({
                            lat: r.lat(),
                            lng: r.lng()
                        });
                    } else {
                        console.log( 'Geocode was not successful for the following reason: ' + status );
                    }
                }
            );

        $curl = curl_init();
        curl_setopt($curl, CURLOPT_URL, 'https://maps.googleapis.com/maps/api/geocode/json?address=' . rawurlencode($address));
        curl_setopt ($curl, CURLOPT_RETURNTRANSFER, 1);
        $json = curl_exec($curl);
        curl_close ($curl);
        */


        // Init maps
        this.map = new gMaps.Map(this.$refs.gMap, {
            zoom: 17,
            center: { lat: this.lat, lng: this.lng },
            mapTypeId: 'roadmap',
            mapTypeControl: 0,
            mapTypeControlOptions: {
                mapTypeIds: [gMaps.MapTypeId.ROADMAP, 'myMapStyleName']
            }
        });

        // Grayscale
        const mapType = new gMaps.StyledMapType(
            [{
                featureType: "all",
                elementType: "all",
                stylers: [{ saturation: -100 }]
            }],
            { name: "Grayscale" }
        );

        this.map.mapTypes.set('myMapStyleName', mapType);
        this.map.setMapTypeId('myMapStyleName');

        // Marker
        new gMaps.Marker({
            position: { lat: this.lat, lng: this.lng },
            map: this.map,
            icon: {
                url: '/assets/map-marker.png',
                size: new gMaps.Size(64, 64),
                origin: new gMaps.Point(0, 0),
                anchor: new gMaps.Point(32, 64)
            },
            title: 'ARA NIERUCHOMOŚCI'
        });
    }
}
</script>

<style scoped lang="scss">
#gMap {
    border-top: solid 1px #666666;
    width: 100%;
    height: 500px;
}
</style>